<template>
  <main class="main page-inside payment-result-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="title big">Your Payout Request Has Been Submitted.</div>
          <div class="desc">
            Your funds will be transferred to your bank account shortly.
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "OfferSuccessPage",
  props: [],
  components: {},
  data: function () {
    return {};
  },
  methods: {},
};
</script>
